import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { Toast } from "../../model/toast";

@Injectable({
  providedIn: "root",
})
export class ToastService {
  private readonly toastSubject = new Subject<Toast>();
  readonly toast$ = this.toastSubject.asObservable();

  show(toast: Toast): void {
    this.toastSubject.next(toast);
  }
}